function isUserLogged() {
    return getAuthUser()?.value?.uuid ? true : false
}

export function goToDonatella() {
    const router = useRouter()
    const { $eventBus } = useNuxtApp()

    if (isUserLogged()) {
        window.open('/donatella', '_blank')
    } else {
        $eventBus.$emit('showDonatellaDialog')
    }
}